import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React, { Fragment } from "react";
import bbcode from "../bbcode";
import withPropMapper from "./withPropMapper";
import { jsx as _jsx } from "react/jsx-runtime";
export function mapBBCodeToReact(input) {
  return typeof input === "string" ? /*#__PURE__*/_jsx(Fragment, {
    children: bbcode.toReact(input)
  }) : input;
}
export function withBBCodeMapper() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }
  if (!keys.length) keys = ["title", "description", "label"];
  return withPropMapper(keys.reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, mapBBCodeToReact));
  }, {}));
}
//# sourceMappingURL=withBBCode.js.map